export enum IssueStatus {
  Open = 'Open',
  Reviewed = 'Reviewed',
  InProgress = 'InProgress',
  Done = 'Done',
  Staged = 'Staged',
  Released = 'Released',
  Closed = 'Closed',
  Parked = 'Parked',
  Rejected = 'Rejected'
}

/** Human-friendly labels for the (camel-case) status enum values. */
export const ISSUE_STATUS_LABELS: Record<string, string> = {
  Open: 'Open',
  Reviewed: 'Reviewed',
  InProgress: 'In Progress',
  Done: 'Done',
  Staged: 'Staged',
  Released: 'Released',
  Closed: 'Closed',
  Parked: 'Parked',
  Rejected: 'Rejected'
};
